import * as React from 'react';
import {
    Box, Card,  IconButton,  Typography,  Dialog,
    DialogContent,
    DialogTitle,
    Tooltip,
    CircularProgress
} from '@mui/material';
import '../Studio/Studio.css';
import CloseIcon from '@mui/icons-material/Close';
import {  VideoSettings } from '@mui/icons-material';
import ScheduledPopup from '../Popup/YouTubePopup/ScheduledPopup';
import VideoEditorEmbed from '../VideoEditorEmbed';
import YouTubePopup from '../Popup/YouTubePopup/YoutubePopup';
import { useLocation } from 'react-router-dom';
import { useReelsWebSocket } from '../../context/ReelWebSocketProvider';


export default function ReelsVideoPlayer({
    allSearchImages,
    scheduledData ,
    sharePopup,
    setSharePopup,
    overlayData,
    onOpenEditor,
    setAllSearchImages,
    handleFetchJson,
    setRenderVideoDetails,
    setSelectedVideoIndex,
    selectedVideoIndex,
    renderVideoDetails,
    setPublishedData,
    publishedData
}: any) {
    const [mainVideo, setMainVideo] = React.useState<string | undefined>(undefined);
    const [viewPopupOpen, setViewPopupOpen] = React.useState(false);
    const [selectedPopupItem, setSelectedPopupItem] = React.useState<any>(null);
    const location = useLocation();
    const {responseData} = useReelsWebSocket(); 
    const [showScheduledPopup, setShowScheduledPopup] = React.useState(true); 

    React.useEffect(() => {
        console.log("webSocketReels", responseData)
           if (responseData) {
               let responseArray = Array.isArray(responseData) ? responseData : [responseData];
               // Deduplicate by _id before merging
               responseArray = responseArray.filter((item, idx, arr) =>
                   item._id ? arr.findIndex(i => i._id === item._id) === idx : true
               );
               if (responseArray.length > 0) {
                   setAllSearchImages((prev: any) => {
                       const filtered = prev.filter((item: any) => item.status !== "IN_PROGRESS");
                       // Only add new items not already present by _id
                       const newItems = responseArray.filter(newItem =>
                           !filtered.some((existing:any) => existing._id === newItem._id)
                       );
                       return [...newItems, ...filtered];
                   });
                   setRenderVideoDetails((prev: any) => {
                       const filtered = prev.filter((item: any) => item.status !== "IN_PROGRESS");
                          // Only add new items not already present by _id
                          const newItems = responseArray.filter(newItem =>
                                !filtered.some((existing:any) => existing._id === newItem._id)
                            );
                          return [...newItems, ...filtered];
                     });

                   
               }
           }
       }, [responseData, setAllSearchImages, setRenderVideoDetails]);

    React.useEffect(() => {
        if (allSearchImages.length > 0) {
            setMainVideo(allSearchImages[0]?.videoUrl || "");
        }
    }, [allSearchImages]);

    const handleSharePopup = (item: any) => {
        if (setSharePopup) setSharePopup(true);
        setSelectedPopupItem(item);
        localStorage.setItem('youtubeLocation', location.pathname)
        localStorage.setItem('youtubeId', item._id);
    }
       
    const handleVideoEditor = (open: boolean) => {
        if (onOpenEditor) onOpenEditor();
        handleFetchJson?.(allSearchImages[selectedVideoIndex]?._id);
    }

    const handleDownload = async () => {
    // Use renderedVideoUrl if available, else fallback to mainVideo
    const fileUrl = renderVideoDetails?.renderedVideoUrl || mainVideo || "";
    if (!fileUrl.startsWith("http://") && !fileUrl.startsWith("https://") && !fileUrl.startsWith("/")) {
        // Optionally show a toast or alert here
        console.error("Invalid file URL for download.");
        return;
    }
    let fileName = fileUrl.split('/').pop()?.split('?')[0] || "podcast-video.mp4";
    if (!fileName.toLowerCase().endsWith('.mp4')) {
        fileName += '.mp4';
    }
    try {
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error("Download failed:", error);
    }
};


    return (
        <Box className="videoComponentContainer">
            
            {(() => {
                const selectedItem = allSearchImages[selectedVideoIndex];
                    const videoData = selectedItem || selectedItem;
                if (selectedItem && selectedItem.status === 'IN_PROGRESS') {
                    // Show image while in progress
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' , position: 'relative' }}>
                            <img
                                src={videoData?.inputData?.imageUrl || videoData.imageUrl || ''}
                                alt="Generating..."
                                style={{ maxWidth: 400, borderRadius: 12, marginBottom: 16 }}
                                className={`${selectedItem && selectedItem.status === 'IN_PROGRESS' ? 'blurMansoryImage' : ''}`}
                            />
                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                                <CircularProgress />
                                </Box>
                            <Typography variant="body1" className='productText'>Video is being generated...</Typography>
                        </Box>
                    );
                } else if (overlayData && Array.isArray(overlayData) && overlayData.length > 0) {
                    // Show video editor if renderJson exists
                    return (
                        <Box sx={{ position: 'relative' }}>
                            <Card className="videoCard">
                                <Box style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, flexDirection: 'row', height: '100%' }}>
                                    <Box>
                                        <Tooltip title="Video Editor" arrow>
                                            <IconButton sx={{ background: '#363333', borderRadius: 0, px: 0.5, py: 0.25 }} onClick={() => handleVideoEditor(true)}>
                                                <VideoSettings />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    <Box>
                                        <IconButton onClick={() => setViewPopupOpen(true)}>
                                            <img src={'/assets/VideoEye.svg'} alt='viewIcon' className='viewIcon' />
                                        </IconButton>
                                    </Box>
                                    <Box>
                                        <IconButton onClick={handleDownload}>
                                            <img src={'/assets/DownloadIcon.svg'} alt="downloadIcon" className="downloadIcon" />
                                        </IconButton>
                                    </Box>
                                    <Box>
                                        <IconButton onClick={() => handleSharePopup(allSearchImages[selectedVideoIndex])}>
                                            <img src={'/assets/ShareIcon.svg'} alt='shareIcon' className='shareIcon' />
                                        </IconButton>
                                        {sharePopup && (
                                            <YouTubePopup
                                                isOpen={sharePopup}
                                                onClose={() => { if (setSharePopup) setSharePopup(false); setSelectedPopupItem(null); }}
                                                videoUrl={selectedPopupItem?.videoUrl || mainVideo || ''}
                                                titlePage="Podcast"
                                                selectedPopupItem={selectedPopupItem}
                                            />
                                        )}
                                    </Box>
                                </Box>
                                <Box sx={{ width: '100%', height: 'calc(100dvh - 195px)', position: 'relative' }}>
                                    <VideoEditorEmbed projectId='test' overlayData={overlayData} editor={false} />
                                </Box>
                            </Card>
                            <Dialog open={viewPopupOpen} onClose={() => setViewPopupOpen(false)}>
                                <Box className="PopupHeader">
                                    <IconButton onClick={() => setViewPopupOpen(false)} className="PopupCloseButton">
                                        <CloseIcon />
                                    </IconButton>
                                </Box>
                                <DialogTitle>Publish Youtube Info</DialogTitle>
                                 <DialogContent>
                                                                    <Box sx={{ minWidth: 250, p: 1 }}>
                                                                        {Array.isArray(publishedData) && publishedData.length > 0 ? (
                                                                            publishedData.map((entry: any, idx: number) => (
                                                                                <Box key={idx} sx={{ mb: 2 }}>
                                                                                    <Typography variant="body1" className='videoPromptText'>
                                                                                        Channel Name:<Typography variant='body1'>{entry.details?.snippet?.channelTitle || entry.channelId || ''}</Typography>
                                                                                    </Typography>
                                                                                    <Typography variant="body1" className='videoPromptText'>
                                                                                        Published Status:<Typography variant='body1'>{entry.status || ''}</Typography>
                                                                                    </Typography>
                                                                                    <Typography variant="body1" className='videoPromptText'>
                                                                                        Published Url: <Typography
                                                                                            variant="body1"
                                                                                            className="linkTextyoutube"
                                                                                            style={{ cursor: entry.youtubeUrl ? 'pointer' : 'default', color: entry.youtubeUrl ? '#1976d2' : undefined }}
                                                                                            onClick={() => {
                                                                                                if (entry.youtubeUrl) window.open(entry.youtubeUrl, '_blank');
                                                                                            }}
                                                                                        >
                                                                                            {entry.youtubeUrl || ''}
                                                                                        </Typography>
                                                                                    </Typography>
                                                                                </Box>
                                
                                                                            ))
                                                                        ) : (
                                                                            <Typography variant="body1">No YouTube publish info available.</Typography>
                                                                        )}
                                                                    </Box>
                                                                </DialogContent>
                            </Dialog>
                        </Box>
                    );
                } else if (selectedItem && (!overlayData || !Array.isArray(overlayData) || overlayData.length === 0)) {
                    // No renderJson for this video
                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 4 }}>
                            <Typography variant="body1">This video does not have renderJson data.</Typography>
                        </Box>
                    );
                } else {
                    return null;
                }
            })()}

            {Array.isArray(scheduledData) && scheduledData.length > 0 && (
                <ScheduledPopup
    open={showScheduledPopup}
    onClose={() => {
        setShowScheduledPopup(false);
        setSharePopup(false);
        setSelectedPopupItem(null);
    }}
    scheduledData={scheduledData}
/>
            )}
        </Box>
    );
}